import React from 'react'
import { useSelector } from 'react-redux'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import { MdPaid } from 'react-icons/md'
import defaultTexts from '../../texts/texts'

const BalanceWrapper = (props) => {
  const { isMobile, handleRefillBalanceDialogOpen } = props
  const theme = useTheme()

  const account_balance = useSelector(state => state.profile.account_balance)

  const user_role = useSelector(state => state.profile.user_role)
  const editPermission = user_role === 'superadmin' || user_role === 'owner' || user_role === 'admin'

  const balanceWrapperStyle = isMobile ?
  {
    padding: '10px 0px',
    cursor: 'pointer',
  } :
  {
    height: '40px',
    borderRadius: '20px',
    background: theme.palette.greenSheen,
    color: 'white',
    fontSize: '20px',
    cursor: 'pointer',
  }

  const iconStyle = {
    color: theme.palette.violetsAreBlue,
  }

  return (
    <>
      <Box
        sx={balanceWrapperStyle}
        onClick={ editPermission ? handleRefillBalanceDialogOpen : () => {} }
      >
        {
          isMobile ?        
          <Stack
            direction='row'
            alignItems='center'
            justifyContent='flex-start'
            spacing={1}                        
          >
            <Box sx={iconStyle}>
              <MdPaid size={32} />
            </Box>
            <Box sx={{ fontSize: '18px' }}>{defaultTexts.balance}: {account_balance} $</Box>
          </Stack> :
          <Stack
            direction='row'
            alignItems='center'
            justifyContent='space-between'
          >
            <Box sx={{ padding: '0px 20px', borderRight: 'white 1px solid' }}>
              <Stack
                alignItems='center'
                justifyContent='center'
                sx={{ height: '40px' }}
              >
                <Box>{defaultTexts.balance}:</Box>
              </Stack>                      
            </Box>
            <Box sx={{ padding: '0px 20px' }}>
              {account_balance} $
            </Box>
          </Stack>
        }
      </Box>
    </>    
  )
}

export default BalanceWrapper